import { ref, watch, reactive, toRaw } from 'vue';
export default (oldForm, newForm) => {
  const changeFields = ref({});
  const oldValues = reactive({});
  const isChanged = ref(false);
  const diffFields = (values, newValues) => {
    const compareObj = (obj1, obj2) => {
      const changes = {};
      for (const k of Object.keys(obj2)) {
        const oldV = obj1[k] || '';
        const newV = obj2[k] || '';
        if (Array.isArray(oldV) && Array.isArray(newV)) {
          if (oldV.length !== newV.length) {
            changes[k] = newV;
            continue;
          }
          for (let i = 0; i < newV.length; i++) {
            if (newV[i] === oldV[i]) continue;
            if (typeof newV[i] === 'object') {
              const subChanges = compareObj(oldV[i], newV[i]);
              if (Object.keys(subChanges).length > 0) {
                changes[k] = newV;
                break;
              }
            } else if (oldV[i] !== newV[i]) {
              changes[k] = newV;
              break;
            }
          }
        } else if (typeof oldV === 'object' && typeof newV === 'object') {
          const subChanges = compareObj(oldV, newV);
          if (Object.keys(subChanges).length > 0) {
            changes[k] = newV;
          }
        } else if (oldV !== newV) {
          changes[k] = newV;
        }
      }
      return changes;
    };
    changeFields.value = compareObj(values, newValues);
    isChanged.value = Object.keys(changeFields.value).length > 0;
  };
  watch(() => newForm, val => {
    const newValues = {
      ...(unref(val) || {})
    };
    const values = unref(oldValues);
    diffFields(values, newValues);
  }, {
    deep: true
  });
  const reset = () => {
    for (const k of Object.keys(oldValues)) {
      delete oldValues[k];
    }
    for (const k of Object.keys(toRaw(oldForm))) {
      oldValues[k] = oldForm[k];
    }
    changeFields.value = {};
  };
  watch(() => oldForm, val => {
    for (const k of Object.keys(oldValues)) {
      delete oldValues[k];
    }
    const rawValue = toRaw(unref(val)) || {};
    for (const k of Object.keys(rawValue)) {
      oldValues[k] = val[k];
    }
    changeFields.value = {};
  }, {
    immediate: true,
    deep: true
  });
  return {
    reset,
    isChanged,
    changeFields
  };
};